import { memo } from "react";
import { HelpdeskTicketInterface } from "shared/types/helpdesk";

export interface DeleteTicketModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  ticket: HelpdeskTicketInterface | null;
  emailCount?: number;
  noteCount?: number;
}

/**
 * DeleteTicketModal - Modal for confirming ticket deletion
 *
 * Features:
 * - Shows count of emails and notes that will be deleted
 * - Clear warning message
 * - Confirm/cancel actions
 */
const DeleteTicketModalComponent = ({
  isOpen,
  onClose,
  onConfirm,
  ticket,
  emailCount = 0,
  noteCount = 0,
}: DeleteTicketModalProps) => {
  if (!isOpen || !ticket) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="w-full max-w-md rounded-xl bg-white p-5 shadow-xl">
        <div className="text-neutral-primary mb-2 text-lg font-semibold">
          Ticket verwijderen
        </div>
        <div className="text-neutral-primary text-sm">
          Je staat op het punt ticket H{ticket.id} te verwijderen.
          <br />
          {emailCount} email{emailCount !== 1 ? "s" : ""} worden verwijderd en{" "}
          {noteCount} notitie{noteCount !== 1 ? "s" : ""} worden verwijderd.
          <br />
          Ben je zeker?
        </div>
        <div className="mt-4 flex justify-end gap-2">
          <button
            className="rounded-md border px-3 py-1.5 text-sm"
            onClick={onClose}
          >
            Annuleren
          </button>
          <button
            className="rounded-md bg-red-600 px-3 py-1.5 text-sm text-white"
            onClick={onConfirm}
          >
            Verwijderen
          </button>
        </div>
      </div>
    </div>
  );
};

export const DeleteTicketModal = memo(DeleteTicketModalComponent);
